<template>
  <div class="noticeDrawer">
    <Drawer
      class="common-drawer notic"
      :title="title"
      v-model="showlistDrawer"
      :width="dologwidth"
      :closable="false"
      :mask-closable="false"
      :scrollable="true"
    >
      <Form
        ref="formValidate"
        :model="formData"
        :rules="ruleValidate"
        label-position="top"
      >
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="标题:" prop="title">
              <Input
                v-model="formData.title"
                placeholder="最多支持20个中文字符"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="发布类型:" prop="publishType">
              <Select
                ref="publishTypetrue"
                :clearable="publishTypetrue"
                :disabled="formData.id"
                v-model="formData.publishType"
              >
                <Option
                  v-for="item in cityList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="内容:" prop="content">
              <Input
                show-word-limit
                v-model="formData.content"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                placeholder="最多支持200个中文字符"
              ></Input>
            </FormItem>
          </Col>

          <Col v-if="formData.publishType == 1" span="24">
            <div class="notic1">
              <FormItem label="上线时间:" prop="effectiveTime">
                <DatePicker
                  :options="options3"
                  @on-change="changeDateOpen"
                  v-model="formData.effectiveTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择年月日、具体时间"
                  style="width: 100%"
                />
              </FormItem>
            </div>
          </Col>
          <Col span="24">
            <div class="notic1">
              <FormItem label="下线时间:">
                <DatePicker
                  :options="options3"
                  @on-change="changeDateExpire"
                  v-model="formData.failureTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择年月日、具体时间"
                  style="width: 100%"
                />
              </FormItem>
            </div>
          </Col>
        </Row>
      </Form>
      <div class="drawer-footer">
        <Button
          type="primary"
          @click="submitForm('formValidate')"
          :loading="btnLoading"
          >{{ formData.publishType == "0" ? "发布" : "确定" }}</Button
        >
        <Button style="margin-left: 8px" @click="clear">取消</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import moment from "moment";
import { mapState } from "vuex";
import { noteadd, noteedit } from "@/api/system/notice";
export default {
  name: "notedrawer",
  props: {
    showlistDrawer: Boolean,
    closeDrawer: Function,
    getLists: Function,
    propForm: Object,
  },
  watch: {
    showlistDrawer() {
      this.formData = this.propForm;

      if (this.formData.id) {
        console.log("this.formData", this.propForm);
        this.title = "修改公告";
      } else {
        this.rest();
        this.title = "新增公告";
      }
    },
  },
  computed: {
    ...mapState({
      dologwidth: (state) => state.dologwidth,
    }),
  },
  data() {
    return {
      publishTypetrue:false,
      cityList: [
        {
          value: 0,
          label: "手动",
        },
        {
          value: 1,
          label: "自动",
        },
      ],
      options3: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      formData: {},
      btnLoading: false,
      title: "",
      formValidate: {
        title: "",
        content: "",
      },
      ruleValidate: {
        //  title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        title: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("请填写标题"));
              } else if (value.length > 20) {
                return callback(new Error("超出字符数限制"));
              } else {
                callback();
              }
            },
          },
        ],
        content: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("请填写内容"));
              } else if (value.length > 200) {
                return callback(new Error("超出字符数限制"));
              } else {
                callback();
              }
            },
          },
        ],
        effectiveTime: [
          {
            required: true,

            trigger: "blur",
            validator: (rule, value, callback) => {
              let effectiveTime = this.formData.effectiveTime;
              if (!effectiveTime) {
                return callback(new Error("请选择上线时间"));
              } else {
                callback();
              }
            },
          },
        ],
        publishType: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              let publishType = this.formData.publishType;
              console.log("publishType", publishType);
              if (publishType === 0 || publishType === 1) {
                callback();
              } else {
                return callback(new Error("请选择发布类型"));
              }
            },
          },
        ],
        // failureTime: [
        //   {
        //     required: true,

        //     trigger: "blur",
        //     validator: (rule, value, callback) => {
        //       let failureTime = this.formData.failureTime;
        //       if (!failureTime) {
        //         return callback(new Error("请选择下线时间"));
        //       } else {
        //         callback();
        //       }
        //     },
        //   },
        // ],
      },
    };
  },
  mounted() {},
  methods: {
    cleartRest() {
      let t = setTimeout(() => {
        console.log("我清空了");
        this.publishTypetrue = true;

        this.$nextTick(async () => {
          this.$refs["publishTypetrue"].clearSingleSelect();

          let t1 = setTimeout(() => {
            this.publishTypetrue = false;

            clearTimeout(t1);
          }, 100);
          clearTimeout(t);
        });
      }, 300);
    },
    async clear() {
      this.closeDrawer();

      await this.$c.sleep(300);
      this.rest();
      this.cleartRest();
    },
    rest() {
      this.$refs["formValidate"].resetFields();
      this.formData = {
        title: "",
        content: "",
        effectiveTime: "",
        failureTime: "",
        publishType: 0,
      };
    },
    changeDateOpen(date) {
      this.formData.effectiveTime = date;
    },
    changeDateExpire(date) {
      console.log("date", date);
      if (date) {
        this.formData.failureTime = date;
      } else {
        this.formData.failureTime = undefined;
      }
    },
    submitForm(name) {
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          // let formData = JSON.parse(JSON.stringify(this.formData));
          let formData = this.$c.deepClone(this.formData);
          // 获取当前时间

          const currentTime = moment();

          // formData.effectiveTime
          if (formData.effectiveTime) {
            formData.effectiveTime = moment(formData.effectiveTime).format(
              "yyyy-MM-DD HH:mm:ss"
            );
            if (moment(formData.effectiveTime).isBefore(currentTime)) {
              this.$Message.info("上线时间应在当前时间之后");
              return;
            }
          }
          console.log("formData.failureTime", formData.failureTime);
          if (formData.failureTime) {
            formData.failureTime = moment(formData.failureTime).format(
              "yyyy-MM-DD HH:mm:ss"
            );
            if (moment(formData.failureTime).isBefore(currentTime)) {
              this.$Message.info("下线时间应在当前时间之后");
              return;
            }
            formData.failureTime = moment(formData.failureTime).format(
              "yyyy-MM-DD HH:mm:ss"
            );
          } else {
            formData.failureTime = null;
          }

          if (formData.failureTime && formData.effectiveTime) {
            const timeString1 = moment(formData.effectiveTime); //上线时间
            const timeString2 = moment(formData.failureTime); //下线时间

            if (!timeString1.isBefore(timeString2)) {
              this.$Message.info("下线时间不能小于上线时间");
              return;
            }
          }

          this.btnLoading = true;
          let fun = "";
          if (this.propForm.id) {
            fun = noteedit;
          } else {
            fun = noteadd;
          }

          fun(formData)
            .then((res) => {
              this.btnLoading = false;
              if (res.code === "00000") {
                this.$Message.success("提交成功");

                this.clear(); // 关闭弹窗
                this.getLists(); // 刷新列表
              }
            })
            .catch((error) => {
              this.formData = {};
              this.btnLoading = false;
            });
        } else {
        }
      });
    },
  },
};
</script>

<style lang='less' >
.notic1 .ivu-btn-primary {
  padding: 0 7px !important;
  color: #fff;
  background: #0c479d !important;
  border-color: #0c479d !important;
}
</style>